export default (timezones) =>
	timezones.map(({timezoneISOID, timezoneName}) => ({
		id: timezoneISOID,
		value: timezoneISOID,
		label: timezoneName
	}));
